module.exports = __webpack_public_path__ + "img/img61.d88a0266.svg";